import { useState, useEffect } from 'react';

function useDebounceSearchTerm(delay: number) {
  // State and setters for debounced value
  const [searchTerm, setSearchTerm] = useState('');
  // Internal debounced value
  // eslint-disable-next-line no-unused-vars
  const [debouncedValue, setDebouncedValue] = useState('');

  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(searchTerm);
      }, delay);

      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [searchTerm, delay] // Only re-call effect if value or delay changes
  );

  return {
    searchTerm,
    setSearchTerm,
    debouncedValue,
  };
}

export default useDebounceSearchTerm;
